module.exports = __webpack_public_path__ + "uKAwi6M3jJIjqSQpK/illo-couple-phone.svg";